import React from 'react';

import UserVehiclesView from 'views/user/vehicles/index.tsx';

export const UserVehicles = () => (
  <UserVehiclesView />

);
export default UserVehicles;
